(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

require('bootstrap/js/dist/modal');

require('../../../modules/modules');

var _utilities = require('./utilities');

var _objectFitImages = require('object-fit-images');

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import 'bootstrap/js/dist/alert'
// import 'bootstrap/js/dist/button'
// import 'bootstrap/js/dist/carousel'

// import 'bootstrap/js/dist/popover'
// import 'bootstrap/js/dist/scrollspy'
// import 'bootstrap/js/dist/tooltip'
// import 'bootstrap/js/dist/tab'
jQuery(function ($) {
  $(document).ready(function () {
    outdatedBrowser({
      bgColor: '#f25648',
      color: '#ffffff',
      lowerThan: 'IE11',
      languagePath: '../node_modules/outdated-browser/outdatedbrowser/lang/en.html'
    });
    (0, _utilities.superscript)();
  });
  $(function () {
    (0, _objectFitImages2.default)();
  });
});

},{"../../../modules/modules":5,"./utilities":2,"bootstrap/js/dist/modal":3,"object-fit-images":4}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
==========================================================================
utility functions
==========================================================================
*/
function getCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length == 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  var expires = '; expires=' + date.toGMTString();
  document.cookie = name + '=' + value + expires + ';path=/';
}

function getParam(p) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;

  var match = RegExp('[?&]' + p + '=([^&]*)').exec(url);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getParams() {
  var query = window.location.search;

  return query ? (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {}) : false;
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function superscript() {
  jQuery(function ($) {
    $('p,h1,h2,h3,h4,h5,h6,li,a,span,td,th,i,b,u,em,strong,del,label,small').contents().filter(function () {
      return this.nodeType === 3;
    }).replaceWith(function () {
      return this.nodeValue.replace(/[®™️]/g, '<sup>$&</sup>');
    });
  });
}

function urlDecode(str) {
  return decodeURIComponent((str + '').replace(/\+/g, '%20'));
}

/*
==========================================================================
class utility
==========================================================================
*/

var RezberryClass = function () {
  _createClass(RezberryClass, [{
    key: 'addListeners',


    /*
    ==========================================================================
    listeners
    ==========================================================================
    */
    value: function addListeners() {
      for (var selector in this.listeners) {
        this.addListener(selector, this.listeners[selector]);
      }
    }
  }, {
    key: 'addListener',
    value: function addListener(selector, listener) {
      if (listener instanceof Array) {
        for (var item in listener) {
          if (!listener.hasOwnProperty(item)) continue;
          this.addListener(selector, listener[item]);
        }
      } else {
        this[selector].on(listener.ev, this[listener.func].bind(this));
      }
    }

    /*
    ==========================================================================
    selectors
    ==========================================================================
    */

  }, {
    key: 'addSelectors',
    value: function addSelectors() {
      for (var name in this.selectors) {
        this.addSelector(name, this.selectors[name]);
      }
    }
  }, {
    key: 'addSelector',
    value: function addSelector(name, selector) {
      this['$' + name] = this.$scope.find(selector);
    }

    /*
    ==========================================================================
    init
    ==========================================================================
    */

  }]);

  function RezberryClass(scope) {
    _classCallCheck(this, RezberryClass);

    this.$scope = jQuery(scope);
  }

  return RezberryClass;
}();

/*
==========================================================================
export
==========================================================================
*/


exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.getParam = getParam;
exports.getParams = getParams;
exports.debounce = debounce;
exports.superscript = superscript;
exports.urlDecode = urlDecode;
exports.RezberryClass = RezberryClass;

},{}],3:[function(require,module,exports){
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0): modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */
var Modal = function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  var NAME = 'modal';
  var VERSION = '4.0.0';
  var DATA_KEY = 'bs.modal';
  var EVENT_KEY = "." + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 300;
  var BACKDROP_TRANSITION_DURATION = 150;
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

  var Default = {
    backdrop: true,
    keyboard: true,
    focus: true,
    show: true
  };
  var DefaultType = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    focus: 'boolean',
    show: 'boolean'
  };
  var Event = {
    HIDE: "hide" + EVENT_KEY,
    HIDDEN: "hidden" + EVENT_KEY,
    SHOW: "show" + EVENT_KEY,
    SHOWN: "shown" + EVENT_KEY,
    FOCUSIN: "focusin" + EVENT_KEY,
    RESIZE: "resize" + EVENT_KEY,
    CLICK_DISMISS: "click.dismiss" + EVENT_KEY,
    KEYDOWN_DISMISS: "keydown.dismiss" + EVENT_KEY,
    MOUSEUP_DISMISS: "mouseup.dismiss" + EVENT_KEY,
    MOUSEDOWN_DISMISS: "mousedown.dismiss" + EVENT_KEY,
    CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
  };
  var ClassName = {
    SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
    BACKDROP: 'modal-backdrop',
    OPEN: 'modal-open',
    FADE: 'fade',
    SHOW: 'show'
  };
  var Selector = {
    DIALOG: '.modal-dialog',
    DATA_TOGGLE: '[data-toggle="modal"]',
    DATA_DISMISS: '[data-dismiss="modal"]',
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Modal =
  /*#__PURE__*/
  function () {
    function Modal(element, config) {
      this._config = this._getConfig(config);
      this._element = element;
      this._dialog = $(element).find(Selector.DIALOG)[0];
      this._backdrop = null;
      this._isShown = false;
      this._isBodyOverflowing = false;
      this._ignoreBackdropClick = false;
      this._originalBodyPadding = 0;
      this._scrollbarWidth = 0;
    } // Getters


    var _proto = Modal.prototype;

    // Public
    _proto.toggle = function toggle(relatedTarget) {
      return this._isShown ? this.hide() : this.show(relatedTarget);
    };

    _proto.show = function show(relatedTarget) {
      var _this = this;

      if (this._isTransitioning || this._isShown) {
        return;
      }

      if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) {
        this._isTransitioning = true;
      }

      var showEvent = $.Event(Event.SHOW, {
        relatedTarget: relatedTarget
      });
      $(this._element).trigger(showEvent);

      if (this._isShown || showEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = true;

      this._checkScrollbar();

      this._setScrollbar();

      this._adjustDialog();

      $(document.body).addClass(ClassName.OPEN);

      this._setEscapeEvent();

      this._setResizeEvent();

      $(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function (event) {
        return _this.hide(event);
      });
      $(this._dialog).on(Event.MOUSEDOWN_DISMISS, function () {
        $(_this._element).one(Event.MOUSEUP_DISMISS, function (event) {
          if ($(event.target).is(_this._element)) {
            _this._ignoreBackdropClick = true;
          }
        });
      });

      this._showBackdrop(function () {
        return _this._showElement(relatedTarget);
      });
    };

    _proto.hide = function hide(event) {
      var _this2 = this;

      if (event) {
        event.preventDefault();
      }

      if (this._isTransitioning || !this._isShown) {
        return;
      }

      var hideEvent = $.Event(Event.HIDE);
      $(this._element).trigger(hideEvent);

      if (!this._isShown || hideEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = false;
      var transition = Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);

      if (transition) {
        this._isTransitioning = true;
      }

      this._setEscapeEvent();

      this._setResizeEvent();

      $(document).off(Event.FOCUSIN);
      $(this._element).removeClass(ClassName.SHOW);
      $(this._element).off(Event.CLICK_DISMISS);
      $(this._dialog).off(Event.MOUSEDOWN_DISMISS);

      if (transition) {
        $(this._element).one(Util.TRANSITION_END, function (event) {
          return _this2._hideModal(event);
        }).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        this._hideModal();
      }
    };

    _proto.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      $(window, document, this._element, this._backdrop).off(EVENT_KEY);
      this._config = null;
      this._element = null;
      this._dialog = null;
      this._backdrop = null;
      this._isShown = null;
      this._isBodyOverflowing = null;
      this._ignoreBackdropClick = null;
      this._scrollbarWidth = null;
    };

    _proto.handleUpdate = function handleUpdate() {
      this._adjustDialog();
    }; // Private


    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default, config);
      Util.typeCheckConfig(NAME, config, DefaultType);
      return config;
    };

    _proto._showElement = function _showElement(relatedTarget) {
      var _this3 = this;

      var transition = Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);

      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
        // Don't move modal's DOM position
        document.body.appendChild(this._element);
      }

      this._element.style.display = 'block';

      this._element.removeAttribute('aria-hidden');

      this._element.scrollTop = 0;

      if (transition) {
        Util.reflow(this._element);
      }

      $(this._element).addClass(ClassName.SHOW);

      if (this._config.focus) {
        this._enforceFocus();
      }

      var shownEvent = $.Event(Event.SHOWN, {
        relatedTarget: relatedTarget
      });

      var transitionComplete = function transitionComplete() {
        if (_this3._config.focus) {
          _this3._element.focus();
        }

        _this3._isTransitioning = false;
        $(_this3._element).trigger(shownEvent);
      };

      if (transition) {
        $(this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        transitionComplete();
      }
    };

    _proto._enforceFocus = function _enforceFocus() {
      var _this4 = this;

      $(document).off(Event.FOCUSIN) // Guard against infinite focus loop
      .on(Event.FOCUSIN, function (event) {
        if (document !== event.target && _this4._element !== event.target && $(_this4._element).has(event.target).length === 0) {
          _this4._element.focus();
        }
      });
    };

    _proto._setEscapeEvent = function _setEscapeEvent() {
      var _this5 = this;

      if (this._isShown && this._config.keyboard) {
        $(this._element).on(Event.KEYDOWN_DISMISS, function (event) {
          if (event.which === ESCAPE_KEYCODE) {
            event.preventDefault();

            _this5.hide();
          }
        });
      } else if (!this._isShown) {
        $(this._element).off(Event.KEYDOWN_DISMISS);
      }
    };

    _proto._setResizeEvent = function _setResizeEvent() {
      var _this6 = this;

      if (this._isShown) {
        $(window).on(Event.RESIZE, function (event) {
          return _this6.handleUpdate(event);
        });
      } else {
        $(window).off(Event.RESIZE);
      }
    };

    _proto._hideModal = function _hideModal() {
      var _this7 = this;

      this._element.style.display = 'none';

      this._element.setAttribute('aria-hidden', true);

      this._isTransitioning = false;

      this._showBackdrop(function () {
        $(document.body).removeClass(ClassName.OPEN);

        _this7._resetAdjustments();

        _this7._resetScrollbar();

        $(_this7._element).trigger(Event.HIDDEN);
      });
    };

    _proto._removeBackdrop = function _removeBackdrop() {
      if (this._backdrop) {
        $(this._backdrop).remove();
        this._backdrop = null;
      }
    };

    _proto._showBackdrop = function _showBackdrop(callback) {
      var _this8 = this;

      var animate = $(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : '';

      if (this._isShown && this._config.backdrop) {
        var doAnimate = Util.supportsTransitionEnd() && animate;
        this._backdrop = document.createElement('div');
        this._backdrop.className = ClassName.BACKDROP;

        if (animate) {
          $(this._backdrop).addClass(animate);
        }

        $(this._backdrop).appendTo(document.body);
        $(this._element).on(Event.CLICK_DISMISS, function (event) {
          if (_this8._ignoreBackdropClick) {
            _this8._ignoreBackdropClick = false;
            return;
          }

          if (event.target !== event.currentTarget) {
            return;
          }

          if (_this8._config.backdrop === 'static') {
            _this8._element.focus();
          } else {
            _this8.hide();
          }
        });

        if (doAnimate) {
          Util.reflow(this._backdrop);
        }

        $(this._backdrop).addClass(ClassName.SHOW);

        if (!callback) {
          return;
        }

        if (!doAnimate) {
          callback();
          return;
        }

        $(this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
      } else if (!this._isShown && this._backdrop) {
        $(this._backdrop).removeClass(ClassName.SHOW);

        var callbackRemove = function callbackRemove() {
          _this8._removeBackdrop();

          if (callback) {
            callback();
          }
        };

        if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) {
          $(this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
        } else {
          callbackRemove();
        }
      } else if (callback) {
        callback();
      }
    }; // ----------------------------------------------------------------------
    // the following methods are used to handle overflowing modals
    // todo (fat): these should probably be refactored out of modal.js
    // ----------------------------------------------------------------------


    _proto._adjustDialog = function _adjustDialog() {
      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      if (!this._isBodyOverflowing && isModalOverflowing) {
        this._element.style.paddingLeft = this._scrollbarWidth + "px";
      }

      if (this._isBodyOverflowing && !isModalOverflowing) {
        this._element.style.paddingRight = this._scrollbarWidth + "px";
      }
    };

    _proto._resetAdjustments = function _resetAdjustments() {
      this._element.style.paddingLeft = '';
      this._element.style.paddingRight = '';
    };

    _proto._checkScrollbar = function _checkScrollbar() {
      var rect = document.body.getBoundingClientRect();
      this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
      this._scrollbarWidth = this._getScrollbarWidth();
    };

    _proto._setScrollbar = function _setScrollbar() {
      var _this9 = this;

      if (this._isBodyOverflowing) {
        // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
        //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
        // Adjust fixed content padding
        $(Selector.FIXED_CONTENT).each(function (index, element) {
          var actualPadding = $(element)[0].style.paddingRight;
          var calculatedPadding = $(element).css('padding-right');
          $(element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this9._scrollbarWidth + "px");
        }); // Adjust sticky content margin

        $(Selector.STICKY_CONTENT).each(function (index, element) {
          var actualMargin = $(element)[0].style.marginRight;
          var calculatedMargin = $(element).css('margin-right');
          $(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this9._scrollbarWidth + "px");
        }); // Adjust navbar-toggler margin

        $(Selector.NAVBAR_TOGGLER).each(function (index, element) {
          var actualMargin = $(element)[0].style.marginRight;
          var calculatedMargin = $(element).css('margin-right');
          $(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) + _this9._scrollbarWidth + "px");
        }); // Adjust body padding

        var actualPadding = document.body.style.paddingRight;
        var calculatedPadding = $('body').css('padding-right');
        $('body').data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
      }
    };

    _proto._resetScrollbar = function _resetScrollbar() {
      // Restore fixed content padding
      $(Selector.FIXED_CONTENT).each(function (index, element) {
        var padding = $(element).data('padding-right');

        if (typeof padding !== 'undefined') {
          $(element).css('padding-right', padding).removeData('padding-right');
        }
      }); // Restore sticky content and navbar-toggler margin

      $(Selector.STICKY_CONTENT + ", " + Selector.NAVBAR_TOGGLER).each(function (index, element) {
        var margin = $(element).data('margin-right');

        if (typeof margin !== 'undefined') {
          $(element).css('margin-right', margin).removeData('margin-right');
        }
      }); // Restore body padding

      var padding = $('body').data('padding-right');

      if (typeof padding !== 'undefined') {
        $('body').css('padding-right', padding).removeData('padding-right');
      }
    };

    _proto._getScrollbarWidth = function _getScrollbarWidth() {
      // thx d.walsh
      var scrollDiv = document.createElement('div');
      scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    }; // Static


    Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        var _config = _extends({}, Modal.Default, $(this).data(), typeof config === 'object' && config);

        if (!data) {
          data = new Modal(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config](relatedTarget);
        } else if (_config.show) {
          data.show(relatedTarget);
        }
      });
    };

    _createClass(Modal, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default;
      }
    }]);

    return Modal;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    var _this10 = this;

    var target;
    var selector = Util.getSelectorFromElement(this);

    if (selector) {
      target = $(selector)[0];
    }

    var config = $(target).data(DATA_KEY) ? 'toggle' : _extends({}, $(target).data(), $(this).data());

    if (this.tagName === 'A' || this.tagName === 'AREA') {
      event.preventDefault();
    }

    var $target = $(target).one(Event.SHOW, function (showEvent) {
      if (showEvent.isDefaultPrevented()) {
        // Only register focus restorer if modal will actually get shown
        return;
      }

      $target.one(Event.HIDDEN, function () {
        if ($(_this10).is(':visible')) {
          _this10.focus();
        }
      });
    });

    Modal._jQueryInterface.call($(target), config, this);
  });
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Modal._jQueryInterface;
  $.fn[NAME].Constructor = Modal;

  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Modal._jQueryInterface;
  };

  return Modal;
}($);

},{}],4:[function(require,module,exports){
/*! npm.im/object-fit-images 3.2.4 */
'use strict';

var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
var supportsObjectFit = 'object-fit' in testImg.style;
var supportsObjectPosition = 'object-position' in testImg.style;
var supportsOFI = 'background-size' in testImg.style;
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
	return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
}

function polyfillCurrentSrc(el) {
	if (el.srcset && !supportsCurrentSrc && window.picturefill) {
		var pf = window.picturefill._;
		// parse srcset with picturefill where currentSrc isn't available
		if (!el[pf.ns] || !el[pf.ns].evaled) {
			// force synchronous srcset parsing
			pf.fillImg(el, {reselect: true});
		}

		if (!el[pf.ns].curSrc) {
			// force picturefill to parse srcset
			el[pf.ns].supported = false;
			pf.fillImg(el, {reselect: true});
		}

		// retrieve parsed currentSrc, if any
		el.currentSrc = el[pf.ns].curSrc || el.src;
	}
}

function getStyle(el) {
	var style = getComputedStyle(el).fontFamily;
	var parsed;
	var props = {};
	while ((parsed = propRegex.exec(style)) !== null) {
		props[parsed[1]] = parsed[2];
	}
	return props;
}

function setPlaceholder(img, width, height) {
	// Default: fill width, no height
	var placeholder = createPlaceholder(width || 1, height || 0);

	// Only set placeholder if it's different
	if (nativeGetAttribute.call(img, 'src') !== placeholder) {
		nativeSetAttribute.call(img, 'src', placeholder);
	}
}

function onImageReady(img, callback) {
	// naturalWidth is only available when the image headers are loaded,
	// this loop will poll it every 100ms.
	if (img.naturalWidth) {
		callback(img);
	} else {
		setTimeout(onImageReady, 100, img, callback);
	}
}

function fixOne(el) {
	var style = getStyle(el);
	var ofi = el[OFI];
	style['object-fit'] = style['object-fit'] || 'fill'; // default value

	// Avoid running where unnecessary, unless OFI had already done its deed
	if (!ofi.img) {
		// fill is the default behavior so no action is necessary
		if (style['object-fit'] === 'fill') {
			return;
		}

		// Where object-fit is supported and object-position isn't (Safari < 10)
		if (
			!ofi.skipTest && // unless user wants to apply regardless of browser support
			supportsObjectFit && // if browser already supports object-fit
			!style['object-position'] // unless object-position is used
		) {
			return;
		}
	}

	// keep a clone in memory while resetting the original to a blank
	if (!ofi.img) {
		ofi.img = new Image(el.width, el.height);
		ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
		ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

		// preserve for any future cloneNode calls
		// https://github.com/bfred-it/object-fit-images/issues/53
		nativeSetAttribute.call(el, "data-ofi-src", el.src);
		if (el.srcset) {
			nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
		}

		setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

		// remove srcset because it overrides src
		if (el.srcset) {
			el.srcset = '';
		}
		try {
			keepSrcUsable(el);
		} catch (err) {
			if (window.console) {
				console.warn('https://bit.ly/ofi-old-browser');
			}
		}
	}

	polyfillCurrentSrc(ofi.img);

	el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
	el.style.backgroundPosition = style['object-position'] || 'center';
	el.style.backgroundRepeat = 'no-repeat';
	el.style.backgroundOrigin = 'content-box';

	if (/scale-down/.test(style['object-fit'])) {
		onImageReady(ofi.img, function () {
			if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
				el.style.backgroundSize = 'contain';
			} else {
				el.style.backgroundSize = 'auto';
			}
		});
	} else {
		el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
	}

	onImageReady(ofi.img, function (img) {
		setPlaceholder(el, img.naturalWidth, img.naturalHeight);
	});
}

function keepSrcUsable(el) {
	var descriptors = {
		get: function get(prop) {
			return el[OFI].img[prop ? prop : 'src'];
		},
		set: function set(value, prop) {
			el[OFI].img[prop ? prop : 'src'] = value;
			nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
			fixOne(el);
			return value;
		}
	};
	Object.defineProperty(el, 'src', descriptors);
	Object.defineProperty(el, 'currentSrc', {
		get: function () { return descriptors.get('currentSrc'); }
	});
	Object.defineProperty(el, 'srcset', {
		get: function () { return descriptors.get('srcset'); },
		set: function (ss) { return descriptors.set(ss, 'srcset'); }
	});
}

function hijackAttributes() {
	function getOfiImageMaybe(el, name) {
		return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
	}
	if (!supportsObjectPosition) {
		HTMLImageElement.prototype.getAttribute = function (name) {
			return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
		};

		HTMLImageElement.prototype.setAttribute = function (name, value) {
			return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
		};
	}
}

function fix(imgs, opts) {
	var startAutoMode = !autoModeEnabled && !imgs;
	opts = opts || {};
	imgs = imgs || 'img';

	if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
		return false;
	}

	// use imgs as a selector or just select all images
	if (imgs === 'img') {
		imgs = document.getElementsByTagName('img');
	} else if (typeof imgs === 'string') {
		imgs = document.querySelectorAll(imgs);
	} else if (!('length' in imgs)) {
		imgs = [imgs];
	}

	// apply fix to all
	for (var i = 0; i < imgs.length; i++) {
		imgs[i][OFI] = imgs[i][OFI] || {
			skipTest: opts.skipTest
		};
		fixOne(imgs[i]);
	}

	if (startAutoMode) {
		document.body.addEventListener('load', function (e) {
			if (e.target.tagName === 'IMG') {
				fix(e.target, {
					skipTest: opts.skipTest
				});
			}
		}, true);
		autoModeEnabled = true;
		imgs = 'img'; // reset to a generic selector for watchMQ
	}

	// if requested, watch media queries for object-fit change
	if (opts.watchMQ) {
		window.addEventListener('resize', fix.bind(null, imgs, {
			skipTest: opts.skipTest
		}));
	}
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;

hijackAttributes();

module.exports = fix;

},{}],5:[function(require,module,exports){
'use strict';

require('./molecules/filter/filter');

require('./molecules/filters/filters');

require('./molecules/browse-menu/browse-menu');

require('./molecules/loading/loading');

require('./molecules/popup-gallery/popup-gallery');

require('./molecules/popup-iframe/popup-iframe');

require('./molecules/overlap/overlap');

require('./molecules/product-filter/product-filter');

require('./molecules/slick/slick');

require('./molecules/search-form/search-form');

require('./molecules/video/video');

require('./molecules/view-more/view-more');

require('./organisms/alert/alert');

require('./organisms/footer-cookies/footer-cookies');

require('./organisms/floating-search/floating-search');

require('./organisms/header/header');

require('./organisms/header-eyebrow/header-eyebrow');

require('./organisms/header-nav/header-nav');

require('./organisms/subnav/subnav');

require('./organisms/01-hero/01-hero');

require('./organisms/03-simple-content/03-simple-content');

require('./organisms/10-testimonials/10-testimonials');

require('./organisms/11-form/11-form');

require('./organisms/13-project-types/13-project-types');

require('./organisms/14-equipment-types/14-equipment-types');

},{"./molecules/browse-menu/browse-menu":6,"./molecules/filter/filter":7,"./molecules/filters/filters":8,"./molecules/loading/loading":9,"./molecules/overlap/overlap":10,"./molecules/popup-gallery/popup-gallery":11,"./molecules/popup-iframe/popup-iframe":12,"./molecules/product-filter/product-filter":13,"./molecules/search-form/search-form":14,"./molecules/slick/slick":15,"./molecules/video/video":16,"./molecules/view-more/view-more":17,"./organisms/01-hero/01-hero":18,"./organisms/03-simple-content/03-simple-content":19,"./organisms/10-testimonials/10-testimonials":20,"./organisms/11-form/11-form":21,"./organisms/13-project-types/13-project-types":22,"./organisms/14-equipment-types/14-equipment-types":23,"./organisms/alert/alert":24,"./organisms/floating-search/floating-search":25,"./organisms/footer-cookies/footer-cookies":26,"./organisms/header-eyebrow/header-eyebrow":27,"./organisms/header-nav/header-nav":28,"./organisms/header/header":29,"./organisms/subnav/subnav":30}],6:[function(require,module,exports){
'use strict';

jQuery(function ($) {
    $(document).ready(function () {
        var checkbox = document.getElementById('dark-toggle');

        function checkIfParamExists() {
            var field = 'av';
            var url = window.location.href;
            if (url.indexOf('?' + field + '=') != -1) {
                checkbox.checked = false;
                document.getElementsByClassName("dot")[0].style.opacity = "0.5";

                checkbox.addEventListener('change', function (event) {
                    var url = new URL(window.location.href);
                    if (!event.currentTarget.checked) {
                        url.searchParams.append('av', 'all');
                        window.location.href = url;
                    } else {
                        url.searchParams.delete('av');
                        document.getElementById('avLabel').style.fontWeight = "bold";
                        window.location.href = url;
                    }
                });
            } else if (url.indexOf('&' + field + '=') != -1) {
                checkbox.checked = false;
                document.getElementsByClassName("dot")[0].style.opacity = "0.5";

                checkbox.addEventListener('change', function (event) {
                    var url = new URL(window.location.href);
                    if (!event.currentTarget.checked) {
                        url.searchParams.append('av', 'all');
                        window.location.href = url;
                    } else {
                        url.searchParams.delete('av');
                        document.getElementById('avLabel').style.fontWeight = "bold";
                        window.location.href = url;
                    }
                });
            } else {
                checkbox.checked = true;
                document.getElementById('avLabel').style.fontWeight = "bold";
                checkbox.addEventListener('change', function (event) {
                    var url = new URL(window.location.href);
                    if (!event.currentTarget.checked) {
                        url.searchParams.append('av', 'all');
                        window.location.href = url;
                    } else {
                        url.searchParams.delete('av');
                        window.location.href = url;
                    }
                });
            }
        }

        checkIfParamExists();
    });
});

},{}],7:[function(require,module,exports){
'use strict';

var _utilities = require('../../../assets/src/js/utilities');

jQuery(function ($) {
  $(document).ready(function () {
    $(document).on('click', '.js-filter-value', function (e) {
      e.preventDefault();

      var $this = $(this),
          $filterWrapper = $this.parents('.js-filter-values').first(),
          endpoint = $filterWrapper.data('endpoint'),
          exclusive = $filterWrapper.data('exclusive'),
          $wrapper = $this.parents('[rez-app]');

      $filterWrapper.find('.js-filter-value').removeClass('is-active');

      if (exclusive) {
        var $otherWrappers = $wrapper.find('.js-filter-values').not($filterWrapper),
            $otherValues = $otherWrappers.find('.js-filter-value');
        $otherValues.removeClass('is-active');
        $otherValues.filter('[data-value="any"]').addClass('is-active');
      }

      $this.addClass('is-active');

      var $active = $wrapper.find('.js-filter-value.is-active').filter(':visible'),
          fields = [],
          operators = [],
          values = [],
          text = '';

      $active.each(function (index, item) {
        var $item = $(item),
            trimmed = $.trim($item.text());

        fields.push($item.data('field'));
        operators.push($item.data('operator') ? $item.data('operator') : 'equal');
        values.push($item.data('value'));

        $wrapper.find('.filter-indicator-' + (index + 1)).text(trimmed);

        if ($item.data('value') != 'any') {
          var newText = $item.data('label') + trimmed;
          text += !text.length ? newText : ', ' + newText;
        }
      });

      if (!text.length) text = 'Everything';
      $('.filters-desktop .filters-indicator').text(text);

      $('.filters-mobile .filters-group').collapse('hide');

      $('.loading').show();
      $.ajax({
        type: 'GET',
        url: endpoint,
        data: {
          fields: fields,
          operators: operators,
          values: values
        },
        success: function success(res) {
          $wrapper.find('.js-filters-stage').first().html(res);
          (0, _utilities.superscript)();
          $('.loading').hide();
        }
      });
    });

    var $active = $('.js-filter-value.is-active').filter(':visible');
    if ($active.length) {
      $active.each(function (index, item) {
        var $item = $(item);
        if ($item.data('value') != 'any') $item.trigger('click');
      });
    }
  });
});

},{"../../../assets/src/js/utilities":2}],8:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.filters-mobile .filters-group').on('show.bs.collapse', function () {
      $(this).parents('.filters-mobile').addClass('is-active');
    });
    $('.filters-mobile .filters-group').on('hidden.bs.collapse', function () {
      $(this).parents('.filters-mobile').removeClass('is-active');
    });
  });
});

},{}],9:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.loading:not(:first)').remove();
  });
});

},{}],10:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  $(document).ready(function () {
    // invadedPadding()
  });

  $(window).on('resize, orientationChange', function () {
    // invadedPadding()
  });

  $('.rez-overlap').each(function () {
    var $section;

    if ($(this).is('section')) {
      $section = $(this);
    } else {
      $section = $(this).parents('section');
    }

    var $prevSection = $section.prev('section').not('.m-subnav');

    $prevSection.addClass('rez-space-invaded');

    $prevSection.each(function () {
      var $pbSection = $(this).filter(function () {
        return this.className.match(/\bpb/);
      }),
          pb;

      $pbSection.filter(function () {
        var classes = $(this).attr('class').split(" ");
        for (var i = 0; i < classes.length; i++) {
          if (classes[i].match('^pb')) {
            pb = classes[i];
          }
        }
      });

      $(this).removeClass(pb);
    });
  });

  function invadedPadding() {
    $('.rez-space-invaded').each(function () {
      var ih = $(this).height(),
          oh = $(this).outerHeight(),
          padding;

      console.log('outer:' + oh + '     inner:' + ih);

      if (ih == oh) {
        $(this).css('height', 'auto').css('height', oh + 100);
      } else {
        padding = (oh - ih) / 2;
        // console.log(pb)
        $(this).css('padding-bottom', padding + 100);
      }
    });
  }
});

},{}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popupGallery = undefined;

var _utilities = require('../../../assets/src/js/utilities');

$(document).ready(function () {
  return popupGallery();
});

function popupGallery() {
  $('.popup-gallery').each(function () {
    $(this).magnificPopup({
      delegate: '.popup-gallery-link:not(.slick-cloned)',
      type: 'image',
      closeBtnInside: false,
      fixedBgPos: true,
      fixedContentPos: true,
      mainClass: 'mfp-img-mobile',
      tLoading: 'Loading image #%curr%...',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1],
        arrowMarkup: '<img alt="%title%" class="m-popup-gallery-arrow mfp-arrow mfp-arrow-%dir%" src="/wp-content/themes/rezberrybud/assets/dist/images/icon-arrow-%dir%-dark.svg">',
        tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
      },
      iframe: {
        tError: '<a href="%url%">The video #%curr%</a> could not be loaded.',
        titleSrc: function titleSrc(item) {
          return item.el.attr('title');
        },
        patterns: {
          youtube: {
            index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

            // id: 'v=', // String that splits URL in a two parts, second part should be %id%
            // Or null - full URL will be returned
            // Or a function that should return %id%, for example:
            // id: function(url) { return 'parsed id'; }
            id: function id(url) {
              return (0, _utilities.getParam)('v', url);
            },

            src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
          },
          vimeo: {
            index: 'vimeo.com/',
            id: '/',
            src: '//player.vimeo.com/video/%id%?autoplay=1'
          },
          wistia: {
            index: 'wistia.com/',
            id: '/medias/',
            src: '//fast.wistia.net/embed/iframe/%id%?videoFoam=true&autoplay=true'
          },
          gmaps: {
            index: '//maps.google.',
            src: '%id%&output=embed'
          }
        },
        markup: '<div class="mfp-iframe-scaler">' + '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' + '</div>' + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + '<h5 class="mfp-counter"></h5>' + '</div>'
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        titleSrc: function titleSrc(item) {
          return item.el.attr('title');
        }
      }
    });
  });
}

exports.popupGallery = popupGallery;

},{"../../../assets/src/js/utilities":2}],12:[function(require,module,exports){
'use strict';

var _utilities = require('../../../assets/src/js/utilities');

jQuery(function ($) {
  $('.popup-iframe-link').magnificPopup({
    type: 'iframe',
    fixedBgPos: true,
    fixedContentPos: true,
    midClick: true,
    iframe: {
      patterns: {
        youtube: {
          index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

          // id: 'v=', // String that splits URL in a two parts, second part should be %id%
          // Or null - full URL will be returned
          // Or a function that should return %id%, for example:
          // id: function(url) { return 'parsed id'; }
          id: function id(url) {
            return (0, _utilities.getParam)('v', url);
          },

          src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
        },
        vimeo: {
          index: 'vimeo.com/',
          id: '/',
          src: '//player.vimeo.com/video/%id%?autoplay=1'
        },
        wistia: {
          index: 'wistia.com/',
          id: '/medias/',
          src: '//fast.wistia.net/embed/iframe/%id%?videoFoam=true&autoplay=true'
        },
        gmaps: {
          index: '//maps.google.',
          src: '%id%&output=embed'
        }
      }
    }
  });
});

},{"../../../assets/src/js/utilities":2}],13:[function(require,module,exports){
"use strict";

jQuery(function ($) {

    $(document).ready(function () {
        // return to previous scroll position if filtering
        if (window.location.href.indexOf("products") > -1 && window.location.href.indexOf("?") > -1) {
            var scrollpos = sessionStorage.getItem('scrollpos');
            if (scrollpos) {
                window.scrollTo(0, scrollpos);
                sessionStorage.removeItem('scrollpos');
            }
        }
        if (window.location.href.split("/").includes("manufacturer")) {
            setTimeout(function () {
                $("input[type=\"checkbox\"][name=\"manufacturer\"][data-mslug=\"" + window.location.href.split("/")[window.location.href.split("/").length - 2] + "\"]").prop('checked', true).trigger('change');
            }, 1000);
        }

        // grab url params
        var urlParams = new URLSearchParams(window.location.search);

        $('.slide-group h4').on('click', function () {
            $(this).parent('.slide-group').toggleClass('open-group');
            $(this).siblings('.slide-group-options').slideToggle(390);
        });

        $('.active-filter').each(function () {
            $(this).addClass('open-group');
            $(this).find('.slide-group-options').slideToggle(390);
        });
    });
    // hide the spinner in case user lands on page via back button
    $(window).on('unload', function () {
        $('.searching-overlay').hide();
    });

    // set scroll position when executing a search
    $(window).on("beforeunload", function () {
        sessionStorage.setItem('scrollpos', window.scrollY);
    });
});

},{}],14:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.m-search-form').submit(function (e) {
      if ($(this).find('[type="search"]').val() == '') {
        e.preventDefault();
      }
    });
  });
});

},{}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
$(document).ready(function () {
  slickThis();
});
$(window).on('resize orientationchange', function () {
  slickThis();
});

function slickThis() {
  $('.slick-this:not(.slick-initialized)').each(function () {
    var adaptiveHeight = $(this).data('height'),
        arrows = $(this).data('arrows'),
        autoplay = $(this).data('autoplay'),
        dots = $(this).data('dots'),
        fade = $(this).data('fade'),
        slidesToScroll = $(this).data('scroll'),
        slidesToShow = $(this).data('show'),
        unslickAt = $(this).data('unslick');
    //$arrows = $(this).siblings('.m-slider-arrows')

    $(this).slick({
      adaptiveHeight: adaptiveHeight,
      arrows: arrows,
      autoplay: autoplay,
      dots: dots,
      fade: fade,
      infinite: true,
      mobileFirst: false,
      //nextArrow: $arrows.find('.m-slider-arrows-arrow-right'),
      //prevArrow: $arrows.find('.m-slider-arrows-arrow-left'),
      rows: 0,
      slidesToScroll: slidesToScroll,
      slidesToShow: slidesToShow,
      pauseOnFocus: true,
      responsive: [{
        breakpoint: unslickAt,
        settings: "unslick"
      }]
    });
  });
}

exports.slickThis = slickThis;

},{}],16:[function(require,module,exports){
'use strict';

// taken from https://codepen.io/team/rcrooks1969/pen/opXWww

jQuery(function () {
  if (typeof videojs == 'undefined') return;

  // Create array for player IDs
  var players = [];

  // +++  Determine the available player IDs +++//
  for (var x = 0; x < Object.keys(videojs.players).length; x++) {
    // Assign the player name to setPlayer
    var setPlayer = Object.keys(videojs.players)[x];
    // Define the ready event for the player
    videojs.getPlayer(setPlayer).ready(function () {
      // Assign this player to a variable
      var myPlayer = this;
      // Assign and event listener for play event
      myPlayer.on('play', onPlay);
      // Push the player to the players array
      players.push(myPlayer);
    });
  }

  // +++ Handle all players' play event +++//
  function onPlay(e) {
    // Determine which player the event is coming from
    var id = e.target.id;
    // Loop through the array of players
    for (var i = 0; i < players.length; i++) {
      // Get the player(s) that did not trigger the play event
      if (players[i].id() != id) {
        // Pause the other player(s)
        videojs.getPlayer(players[i].id()).pause();
      }
    }
  }
});

},{}],17:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  var ww = window.innerWidth;

  $(document).ready(function () {
    moduleShowToggle();
  });
  $(window).on('resize orientationchange', function () {
    moduleShowToggle();
  });

  function moduleShowToggle() {
    if (ww == window.innerWidth) return;
    $('.m-view-toggle').each(function () {
      var $this = $(this),
          $section = $this.parents('section'),
          cutoff = $this.data('cutoff'),
          numToShow = $this.data('num-to-show'),
          $more = $this.find('.view-more'),
          $less = $this.find('.view-less'),
          $toggleContainer = $section.find('.toggle-this-container');

      $section.find('.toggle-this:lt(' + cutoff + ')').show();
      var items = $section.find('.toggle-this').length,
          shown = cutoff;

      $more.click(function () {
        $(this).siblings('.view-less').show();
        var remaining = items - shown;
        // console.log($toggleContainer)
        if (remaining < numToShow) {
          shown = shown + remaining;
        } else {
          shown = shown + numToShow;
        }
        if (shown < items) {
          $toggleContainer.find('.toggle-this:lt(' + shown + ')').show(300);
        } else {
          $toggleContainer.find('.toggle-this:lt(' + items + ')').show(300);
          $(this).hide();
        }
      });

      if ($less.length) {
        less.click(function () {
          var hide = items - cutoff;
          $('html, body').animate({
            scrollTop: $toggleContainer.parent().offset().top
          }, 300);
          $toggleContainer.find('.toggle-this').not(':lt(' + cutoff + ')').hide(300);
          $(this).hide();
          $(this).siblings('.view-more').show();
          shown = cutoff;
        });
      }
    });

    ww = window.innerWidth;
  }
});

},{}],18:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  var slider = $('.m-rez-hero-slides');

  $(document).ready(function () {
    slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var currentVideo = $('[data-slick-index="' + currentSlide + '"]').find('video'),
          nextVideo = $('[data-slick-index="' + nextSlide + '"]').find('video');
      if (currentVideo.length) {
        currentVideo.get(0).pause();
      }
      if (nextVideo.length) {
        nextVideo.get(0).play();
      }
    });
    slider.on('init reInit', function () {
      var currentVideo = $('[data-slick-index="0"]').find('video');
      if (currentVideo.length) {
        currentVideo.get(0).play();
      }
    });
    slider.slick({
      infinite: true,
      rows: 0,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [{
        breakpoint: 767,
        settings: {
          // arrows: false,
          // dots: true
        }
      }]
    });
  });

  $(window).on('resize orientationchange', function () {
    slider.slick('resize');
  });
});

},{}],19:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $('.m-basic-content').each(function () {
    $(this).find('.m-basic-content-content').children().last().addClass('mb-0');
  });
});

},{}],20:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    quoteSize();
    moduleMargin();
    quoteHeight();
    moduleHeight();
  });
  $(window).on('resize orientationchange', function () {
    moduleMargin();
    quoteHeight();
    moduleHeight();
  });

  function moduleHeight() {
    $('.m-testimonials').each(function () {
      var leftH = $(this).find('.m-testimonials-left').height();
      var rightH = $(this).find('.m-testimonials-right').height();
      if ($(window).innerWidth() >= 768) {
        if (leftH > rightH) {
          $(this).find('.m-testimonials-right').css('height', leftH);
        } else {
          $(this).find('.m-testimonials-left').css('height', rightH);
        }
      } else {
        $(this).find('.m-testimonials-right, .m-testimonials-left').css('height', 'auto');
      }
    });
  }

  function quoteHeight() {
    $('.m-testimonials').each(function () {
      var maxHeight = Math.max.apply(null, $(this).find('.m-testimonials-quote-content').map(function () {
        return $(this).height();
      }).get());
      var newHeight = maxHeight + 30;
      $(this).find('.m-testimonials-quote-wrapper').css('height', newHeight);
    });
  }

  function quoteSize() {
    $('.m-testimonials').each(function () {
      $(this).find('.m-testimonials-quote').each(function () {
        var length = $(this).text().length;
        console.log(length);
        if (length > 200) {
          $(this).addClass('text-smaller');
        }
      });
    });
  }

  function moduleMargin() {
    var windowW = $(window).innerWidth();
    var containerW = $('.container').width();
    if (windowW >= 1400) {
      var margin = (windowW - containerW) / 2 - 30;
      // var width = (windowW / 2) - 50
      var width = windowW / 2 - 300;

      $('.m-testimonials').each(function () {
        $(this).find('.m-testimonials-left .m-testimonials-intro').css('margin-left', margin);
        $(this).find('.m-testimonials-right .m-testimonials-carousel-wrapper').css('margin-right', margin);
      });
    } else {
      $('.m-testimonials').each(function () {
        $(this).find('.m-testimonials-left .m-testimonials-intro').css('margin-left', '0');
        $(this).find('.m-testimonials-right .m-testimonials-carousel-wrapper').css('margin-right', '0');
      });
    }
  }
});

},{}],21:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  function allFormThings() {
    $('.floating .ginput_container input, .floating .ginput_container .textarea').each(function () {
      if ($(this).val() !== '') {
        $(this).parents('.ginput_container').siblings('label').addClass('focused');
      }
    });

    $('.floating .ginput_container input, .floating .ginput_container .textarea').on('focus keyup', function () {
      var fcolor = 'orange';
      if ($(this).parents('form').hasClass('form-light-bg')) {
        fcolor = 'orange';
      }
      $(this).parents('.ginput_container').siblings('label').addClass('focused').addClass(fcolor);
      if ($(this).val().length < 0) {
        $(this).parents('.ginput_container').siblings('label').addClass('focused').addClass(fcolor);
      }
    });
    $('.floating .ginput_container input, .floating .ginput_container .textarea').on('blur', function () {
      var fcolor = 'orange';
      if ($(this).parents('form').hasClass('form-light-bg')) {
        fcolor = 'orange';
      }
      if ($(this).val().length == '') {
        $(this).parents('.ginput_container').siblings('label').removeClass('focused').removeClass(fcolor);
      } else {
        $(this).parents('.ginput_container').siblings('label').removeClass(fcolor);
      }
    });

    $('.gform_wrapper .gfield.floating > .ginput_container > input, .gfield.floating.gfield_contains_required > .ginput_container .textarea').on('blur', function () {
      if ($(this).val() === '') {
        if ($(this).parents('.gfield').hasClass('gfield_contains_required')) {
          $(this).parents('.gfield.gfield_contains_required').addClass('warning');
        } else {
          $(this).parents('.gfield').removeClass('warning');
        }
      } else {
        $(this).parents('.gfield').removeClass('warning');
      }
    });
  }

  jQuery(document).on('gform_post_render', function () {
    allFormThings();
  });

  $(document).ready(function () {
    allFormThings();
  });

  $(window).on('load', function () {
    $('.gform_wrapper .ginput_container_checkbox').each(function () {
      $(this).parents('.gfield').addClass('gf-checkbox');
    });
    $('.gform_wrapper .ginput_container_radio').each(function () {
      $(this).parents('.gfield').addClass('gf-radio');
    });
    $('.gform_wrapper .ginput_container_fileupload').each(function () {
      $(this).parents('.gfield').addClass('gf-file');
    });
    $('.gform_wrapper .ginput_container_select').each(function () {
      var fcolor = 'orange';
      if ($(this).parents('form').hasClass('form-light-bg')) {
        fcolor = 'orange';
      }
      $(this).parents('.gfield').addClass('gf-select');
      $(this).siblings('label').addClass('focused');
    });

    $('textarea').each(function () {
      var offset = this.offsetHeight - this.clientHeight;
      $(this).addClass('hello');

      var resizeArea = function resizeArea(el) {
        $(el).css('height', '59px').css('height', el.scrollHeight + offset);
        $(el).parents('.ginput_container_textarea').css('height', el.scrollHeight + offset);
      };

      $(this).on('keyup input', function () {
        console.log(offset);
        resizeArea(this);
      });
    });
  });
});

},{}],22:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    breakAnd();
  });

  function breakAnd() {
    $('.m-project-types').each(function () {
      $(this).find('.m-project-types-card').each(function () {
        var string = $(this).find('h3').text();
        if (string.includes(" and ")) {
          var newString = string.replace(' and ', '</br>and</br>');
          $(this).find('h3').html(newString);
        }
      });
    });
  }
});

},{}],23:[function(require,module,exports){
'use strict';

$(document).ready(function () {
  equipmentSlickThis();
});
$(window).on('load', function () {
  //equipmentImageSize()
});
$(window).on('resize orientationchange', function () {
  equipmentSlickThis();
});

function equipmentSlickThis() {
  $('.slick-this-eq:not(.slick-initialized)').each(function () {
    var adaptiveHeight = $(this).data('height'),
        arrows = $(this).data('arrows'),
        autoplay = $(this).data('autoplay'),
        dots = $(this).data('dots'),
        unslickAt = $(this).data('unslick');
    //$arrows = $(this).siblings('.m-slider-arrows')

    $(this).slick({
      //adaptiveHeight: adaptiveHeight,
      arrows: arrows,
      autoplay: autoplay,
      dots: dots,
      infinite: false,
      mobileFirst: true,
      //nextArrow: $arrows.find('.m-slider-arrows-arrow-right'),
      //prevArrow: $arrows.find('.m-slider-arrows-arrow-left'),
      rows: 0,
      slidesToScroll: 2,
      slidesToShow: 2,
      lazyLoad: 'ondemand',
      responsive: [{
        breakpoint: 567,
        settings: {
          slidesToScroll: 3,
          slidesToShow: 3
        }
      }, {
        breakpoint: 767,
        settings: {
          slidesToScroll: 4,
          slidesToShow: 4
        }
      }, {
        breakpoint: 991,
        settings: {
          slidesToScroll: 5,
          slidesToShow: 5
        }
      }]
    });
  });
}

},{}],24:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    alertSize();

    if ($('.m-alert').length) {
      if (sessionStorage.getItem('alertState') != 'dismissed') {
        rezAlert();
      } else {
        $('.m-alert').hide();
        $('body').css('padding-bottom', 0);
      }
    }
  });

  $(window).on('resize orientationchange', function () {
    alertSize();
  });

  function rezAlert() {
    $('.m-alert').css('opacity', 1);

    $('.m-alert .close').on('click', function () {
      $('.m-alert').hide();
      $('body').css('padding-bottom', 0);
      sessionStorage.setItem('alertState', 'dismissed');
    });
  }

  function alertSize() {
    $('body').css('padding-bottom', 0);
    if ($('.m-alert').length) {
      var ah = $('.m-alert').height();
      $('body').css('padding-bottom', ah);
    }
  }
});

},{}],25:[function(require,module,exports){
'use strict';

var initFloatingSearch = function initFloatingSearch() {
  var $floatingSearch = $('.m-floating-search');
  if (!$floatingSearch.length) return;

  var $button = $floatingSearch.find('.m-floating-search__button');
  var $modal = $floatingSearch.find('.m-floating-search__modal');
  var $input = $floatingSearch.find('.m-floating-search__input');
  var $close = $floatingSearch.find('.m-floating-search__close');

  if (!$button.length || !$modal.length || !$input.length) return;

  var openModal = function openModal() {
    $modal.attr('aria-hidden', 'false');
    $input.focus();
    $('body').css('overflow', 'hidden');
  };

  var closeModal = function closeModal() {
    $modal.attr('aria-hidden', 'true');
    $('body').css('overflow', '');
  };

  $button.on('click', openModal);
  $close.on('click', closeModal);

  $modal.on('click', function (e) {
    if (e.target === $modal[0]) {
      closeModal();
    }
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $modal.attr('aria-hidden') === 'false') {
      closeModal();
    }
  });
};

$(document).ready(initFloatingSearch);

},{}],26:[function(require,module,exports){
"use strict";

$(function () {

  function createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1, c.length);
      }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  $('#dismissCookies').on('click', function () {
    $('.m-footer-cookies').hide();
    createCookie('cookie_notice_hidden', 'true', 7);
  });

  var visited = readCookie('cookie_notice_hidden');
  if (!visited || visited !== "true") {
    $('.m-footer-cookies').css('display', 'flex');
  }
});

},{}],27:[function(require,module,exports){
'use strict';

var _headerNav = require('../header-nav/header-nav');

jQuery(function ($) {
  $(document).ready(function () {
    $('.m-search-form input').on('focus keyup', function () {
      $(this).parents('.m-search-form').addClass('focused');
    });
    $('.m-search-form input').on('blur', function () {
      if ($(this).val() === '') {
        $(this).parents('.m-search-form').removeClass('focused');
      }
    });

    $('.m-header-eyebrow-search-toggle').click(function (e) {
      e.preventDefault();
      if (_headerNav.$searchForm.is(':visible')) {
        _headerNav.$overlay.hide();
        $(this).removeClass('is-active');
        _headerNav.$searchForm.velocity('finish').velocity('slideUp', {
          duration: 250,
          easing: 'easeInOut'
        });
        (0, _headerNav.scrollReset)();
      } else {
        (0, _headerNav.hideAllTheThings)(false);
        _headerNav.$overlay.show();
        $(this).addClass('is-active');
        (0, _headerNav.scrollOverride)();
        _headerNav.$searchForm.velocity('finish').velocity('slideDown', {
          duration: 250,
          easing: 'easeInOut',
          complete: function complete() {
            $(this).find('[type="search"]').focus();
          }
        });
      }
    });
  });
});

},{"../header-nav/header-nav":28}],28:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollReset = exports.scrollOverride = exports.$searchForm = exports.$overlay = exports.navBreakpoint = exports.hideAllTheThings = undefined;

var _utilities = require('../../../assets/src/js/utilities');

var $anchors2 = jQuery('.m-header-nav-list > li > a').not('.click-through'),
    $anchors = jQuery('.m-header-nav-item-inner > .m-header-nav-chevron-mobile'),
    $overlay = jQuery('.m-header-nav-overlay'),
    $searchForm = jQuery('.m-header-eyebrow-search'),
    $header = jQuery('.m-header'),
    navBreakpoint = 992,
    st = 0;

jQuery(function ($) {
  $(document).ready(function () {
    $('.m-header-nav-toggle').off('click');
    $('.m-header-nav-toggle').click((0, _utilities.debounce)(function (e) {
      e.preventDefault();
      if (!$(this).data('is-open')) {
        $('.m-header-nav-nav').velocity('finish').velocity('slideDown', {
          duration: 250,
          begin: function begin() {
            $header.css({
              'bottom': 0,
              'overflow-y': 'scroll'
            });
            scrollOverride();
          }
        });
        $(this).data('is-open', true);
      } else {
        hideAllTheThings(true);
        $('.m-header-nav-nav').velocity('finish').velocity('slideUp', {
          duration: 0,
          complete: function complete() {
            $header.css({
              'bottom': 'auto',
              'overflow-y': 'visible'
            });
            scrollReset();
          }
        });
        $(this).data('is-open', false);
      }
      $(this).toggleClass('is-active');
      $('.m-header-nav-nav').toggleClass('is-active');
    }, 500, true));

    $('.m-header-nav-item-close').click(function (e) {
      e.preventDefault();
      hideAllTheThings(true);
      scrollReset();
    });

    // separate click event needed to always prevent default
    $anchors.click(function (e) {
      e.preventDefault();
    });

    $anchors.click((0, _utilities.debounce)(function () {
      var $dropdown = $(this).parents('.m-header-nav-item-inner').next('.m-header-nav-item');
      var $anchorClass = 'level1';
      if ($(this).hasClass('m-header-sub-nav-chevron-mobile')) {
        $dropdown = $(this).parents('.m-header-sub-nav-items').find('.m-header-nav-item');
        $anchorClass = 'level2';
      }
      $anchors.removeClass('is-active');
      if ($('.m-header-nav-back').hasClass('level1')) {
        $('.m-header-nav-back').removeClass('level1').addClass('level2');
      } else {
        $('.m-header-nav-back').addClass('level1');
      }
      if (window.innerWidth >= navBreakpoint) {
        if ($dropdown.is(':visible')) {
          hideDropdown($dropdown, false, $.noop);
          $overlay.hide();
          scrollReset();
        } else {
          $(this).addClass('is-active');
          showDropdown($dropdown);
          $overlay.show();
        }
      } else {
        $(this).addClass('is-active');
        showDropdown($dropdown);
      }
    }, 500, true));

    $('.m-header-nav-back').click(function () {
      if (window.innerWidth <= navBreakpoint - 1) {
        hideAllTheThings(false);
      }
    });

    $overlay.click(function () {
      hideSearchForm();
      hideAllTheThings(false);
      scrollReset();
    });
  });

  function showDesktopChild($child) {
    hideDropdown($('.m-header-nav-item.reveal'), true, function () {
      $('.children.reveal, .grandchildren.reveal').removeClass('reveal');
      $child.addClass('reveal');
      $('.m-header-nav-nav').addClass('has-open-dropdown');
      $child.velocity('finish').velocity('slideDown', {
        duration: 400,
        easing: 'easeInOut',
        begin: function begin() {
          st = $(window).scrollTop();
        },
        complete: function complete() {
          showDropdownChildren($child);
        }
      });
    });
  }

  function desktopNav() {
    if (window.innerWidth >= navBreakpoint - 1) {
      // if on desktop

      // check for menus that would be cut off on the right side of screen
      $('.m-header-nav-item.children').each(function () {
        $(this).css('opacity', 0);
        $(this).show();
        var ddoffset = $(this).offset();
        var ddl = ddoffset.left;
        var ddwidth = $(this).width();
        var docw = $('.m-header-nav').width();
        var isEntirelyVisible = ddl + ddwidth <= docw;
        if (!isEntirelyVisible) {
          $(this).addClass('menu-edge');
        } else {
          $(this).removeClass('menu-edge');
          var gc = $(this).find('.grandchildren'); // even if child is not off screen, grandchildren might be
          if (gc.length > 0) {
            gc.css('opacity', 0);
            gc.show();
            var gcw = gc.width();
            var areGcVisible = ddl + ddwidth + gcw <= docw;
            if (!areGcVisible) {
              $(this).addClass('gc-edge');
            } else {
              $(this).removeClass('gc-edge');
            }
            gc.hide();
            gc.css('opacity', 1);
          }
        }
        $(this).hide();
        $(this).css('opacity', 1);
      });

      // show dropdown
      $('.m-header-nav-items.parent > .m-header-nav-item-inner > a').on('mouseenter', function () {
        var $dropdown = $(this).parent().siblings('.m-header-nav-item');
        $('.m-header-nav-item-inner .primary-nav-anchor-tracking').not($(this)).removeClass('is-active');
        if ($dropdown.hasClass('children') || $dropdown.hasClass('grandchildren')) {
          if (!$(this).hasClass('is-active')) {
            $(this).addClass('is-active');
            showDesktopChild($dropdown);
          }
        } else {
          hideDropdown($('.m-header-nav-item.reveal'), true, $.noop);
        }
      });

      // show grandchildren
      $('.m-header-nav-item.children a').on('mouseenter', function () {
        var $dropdown = $(this).parent().siblings('.m-header-nav-item');
        if ($dropdown.hasClass('grandchildren')) {
          if (!$(this).hasClass('is-active')) {
            $(this).addClass('is-active');
            $dropdown.addClass('reveal');
            $dropdown.velocity('finish').velocity('slideDown', {
              duration: 400,
              easing: 'easeInOut',
              begin: function begin() {
                st = $(window).scrollTop();
              },
              complete: function complete() {
                showDropdownChildren($dropdown);
              }
            });
          }
        }
      });

      // hide active dropdown when leaving menu from top nav items
      $('.m-header-nav-list').on('mouseleave', function () {
        hideDropdown($('.m-header-nav-item.reveal'), true, function () {
          $('a.is-active').removeClass('is-active');
        });
      });

      // hide active dropdown when leaving it
      $('.m-header-nav-item.children').on('mouseleave', function () {
        if (!$('.grandchildren').hasClass('reveal')) {
          var $dropdown = $(this);
          $dropdown.removeClass('reveal');
          $('a.is-active').removeClass('is-active');
          $dropdown.velocity('finish').hide();
        }
      });
    } else {
      // mobile - turn off desktop functionality
      $('.m-header-nav-items.parent > .m-header-nav-item-inner > a').off('mouseenter');
      $('.m-header-nav-item.children a').off('mouseenter');
      $('.m-header-nav-list').off('mouseleave');
      $('.m-header-nav-item.children').off('mouseleave');
    }
  };
  $(document).ready(desktopNav);
  $(window).resize(desktopNav);
});

var ww = window.innerWidth;
$(window).resize(function () {
  if (ww == window.innerWidth) return;
  var $dropdown = $('.m-header-nav-item');
  if (window.innerWidth <= navBreakpoint - 1) {
    $dropdown.each(function () {
      this.style.transform = 'translateX(100%)';
    });
    hideAllTheThings(true);
    $('.m-header-nav-back').hide();
    if ($('.m-header-nav-toggle').data('is-open') == true) {
      $header.css({
        'bottom': 0,
        'overflow-y': 'scroll'
      });
      scrollOverride();
    } else {
      $header.css({
        'bottom': 'auto',
        'overflow-y': 'visible'
      });
      scrollReset();
    }
  } else {
    $dropdown.each(function () {
      this.style.transform = 'none';
    });
    $('.m-header-nav-back').hide();
    $header.css({
      'bottom': 'auto',
      'overflow-y': 'visible'
    });
    if (!$dropdown.filter(':visible').length) {
      scrollReset();
    }
  }
  ww = window.innerWidth;
});

function showDropdown($dropdown) {
  jQuery(function ($) {
    $('.m-header-nav-nav').addClass('has-open-dropdown');
    hideSearchForm();
    if (window.innerWidth >= navBreakpoint) {
      if ($('.m-header-nav-item:visible').length) {
        hideDropdown($('.m-header-nav-item:visible'), false, $.noop);
        $dropdown.velocity('finish').show();
        showDropdownChildren($dropdown);
      } else {
        $dropdown.velocity('finish').velocity('slideDown', {
          duration: 400,
          easing: 'easeInOut',
          begin: function begin() {
            st = $(window).scrollTop();
          },
          complete: function complete() {
            showDropdownChildren($dropdown);
          }
        });
      }
    } else {
      $dropdown.velocity('finish').velocity({
        translateX: [0, '100%']
      }, {
        duration: 200,
        easing: 'easeInOut',
        display: 'block',
        complete: function complete() {
          showDropdownChildren($dropdown);
        }
      });
      var label = $dropdown.siblings('.m-header-nav-item-inner').find('.m-header-nav-item-label').text();
      $('.m-header-nav-back').text(label).velocity('finish').velocity({
        translateX: [0, '100%']
      }, {
        duration: 200,
        easing: 'easeInOut',
        display: 'block'
      });
    }
  });
}

function hideDropdown($dropdown, immediate, _callback) {
  jQuery(function ($) {
    $('.m-header-nav-nav').removeClass('has-open-dropdown');
    if (window.innerWidth >= navBreakpoint) {
      $dropdown.velocity('finish').hide();
    } else {
      $dropdown.velocity('finish').velocity({
        translateX: ['100%', 0]
      }, {
        duration: immediate ? 0 : 200,
        easing: 'easeInOut',
        display: 'none'
      });
      $('.m-header-nav-back').velocity('finish').velocity({
        translateX: ['100%', 0]
      }, {
        duration: immediate ? 0 : 200,
        easing: 'easeInOut',
        display: 'none'
      });
    }
    _callback();
  });
}

function hideAllTheThings(immediate) {
  var $dropdown = $('.m-header-nav-item:visible');
  // var $dropdown = $('.m-header-nav-list-child:visible')
  hideDropdown($dropdown, immediate, $.noop);
  $anchors.removeClass('is-active');
  $overlay.hide();
}

function hideSearchForm() {
  $('.m-header-eyebrow-search-toggle').removeClass('is-active');
  $searchForm.hide();
}

function showDropdownChildren($dropdown) {
  $dropdown.find('.m-header-nav-list-child').show();
  $dropdown.velocity('finish').velocity({
    translateX: ['0', 0]
  }, {
    duration: 200,
    easing: 'easeInOut',
    display: 'block'
  });
}

$.fn.extend({
  staggerFade: function staggerFade() {
    var display = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if ($(this).css('opacity') == 0) {
      var settings = {
        duration: 1000,
        stagger: 100,
        display: display,
        drag: true
      };
      $(this).velocity('transition.fadeIn', settings);
    }
  }
});

function scrollOverride() {
  st = $(window).scrollTop();
  $('html, body').css({
    'overflow-y': 'hidden',
    'height': '100%'
  });
}

function scrollReset() {
  $('html, body').css({
    'overflow-y': 'visible',
    'height': 'auto'
  });
  if (st > 0) $(window).scrollTop(st);
}

exports.hideAllTheThings = hideAllTheThings;
exports.navBreakpoint = navBreakpoint;
exports.$overlay = $overlay;
exports.$searchForm = $searchForm;
exports.scrollOverride = scrollOverride;
exports.scrollReset = scrollReset;

},{"../../../assets/src/js/utilities":2}],29:[function(require,module,exports){
'use strict';

var _headerNav = require('../header-nav/header-nav');

var _subnav = require('../subnav/subnav');

var ls = 0,
    $header = $('.m-header'),
    $eyebrow = $('.m-header-eyebrow'),
    $subnav = $('.js-subnav'),
    headerHeight,
    eyebrowHeight;

jQuery(function ($) {
  $(document).ready(function () {
    headerHeight = $header.outerHeight();
    if (window.innerWidth <= _headerNav.navBreakpoint - 1) {
      eyebrowHeight = 0;
    } else {
      eyebrowHeight = $eyebrow.outerHeight();
    }
    if ($(window).scrollTop() > 0) {
      scrollStuff();
    }
  });
  $(window).scroll(function () {
    (0, _subnav.toggleDockSubnav)();
    scrollStuff();
  });
  $(window).resize(function () {
    headerHeight = $header.outerHeight();
    if (window.innerWidth <= _headerNav.navBreakpoint - 1) {
      eyebrowHeight = 0;
    } else {
      eyebrowHeight = $eyebrow.outerHeight();
    }
  });
});

function scrollStuff() {

  jQuery(function ($) {
    var st = $(window).scrollTop();
    if (st >= headerHeight && st > ls && $header.data('is-visible')) {
      // hide on scroll down
      $header.velocity('finish').velocity({
        translateY: -headerHeight
      }, {
        duration: 400,
        easing: 'easeInOut',
        queue: false,
        progress: function progress() {
          return (0, _subnav.toggleDockSubnav)();
        }
      });
      $subnav.velocity('finish').velocity({
        translateY: 0
      }, {
        duration: 400,
        easing: 'easeInOut',
        queue: false
      });
      $eyebrow.data('is-visible', false);
      $header.data('is-visible', false);
    } else if (st < ls && !$header.data('is-visible')) {
      // show on scroll up
      $header.velocity('finish').velocity({
        translateY: -eyebrowHeight
      }, {
        duration: 400,
        easing: 'easeInOut',
        queue: false,
        progress: function progress() {
          return (0, _subnav.toggleDockSubnav)();
        }
      });
      $subnav.velocity('finish').velocity({
        translateY: headerHeight - eyebrowHeight
      }, {
        duration: 400,
        easing: 'easeInOut',
        queue: false
      });
      $eyebrow.data('is-visible', false);
      $header.data('is-visible', true);
    } else if (st <= eyebrowHeight) {
      // show eyebrow when top of page is hit
      $header.velocity('finish').velocity({
        translateY: 0
      }, {
        duration: 150,
        easing: 'easeInOut',
        queue: false
      });
      $subnav.velocity('finish').velocity({
        translateY: [headerHeight, $subnav.getTranslateY()]
      }, {
        duration: 150,
        easing: 'easeInOut',
        queue: false
      });
      $eyebrow.data('is-visible', true);
    }
    ls = st;
  });
}

},{"../header-nav/header-nav":28,"../subnav/subnav":30}],30:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleDockSubnav = undefined;

var _headerNav = require('../header-nav/header-nav');

var subnavWaypoint,
    $header = $('.m-header'),
    $eyebrow = $('.m-header-eyebrow'),
    $subnav = $('.js-subnav'),
    subnavIsDockable;

$(document).ready(function () {

  subnavIsDockable = $subnav.hasClass('is-dockable');

  addSubnavWrapper();

  $('.m-subnav-toggle').click(function () {
    if (window.innerWidth >= _headerNav.navBreakpoint) return;
    $(this).toggleClass('is-active');
    var $nav = $('.m-subnav-nav');
    if ($nav.is(':visible')) {
      $('.m-subnav-nav').velocity('slideUp', {
        duration: 250,
        easing: 'easeInOut'
      });
    } else {
      $('.m-subnav-nav').velocity('slideDown', {
        duration: 250,
        easing: 'easeInOut'
      });
    }
  });

  if (window.innerWidth <= _headerNav.navBreakpoint - 1) {
    var backlink = $.trim($('.m-subnav-back-title').text()),
        $active = $('.m-subnav-nav-list a.is-active').first(),
        active = $.trim($active.text());
    if ($active.length && active !== backlink) {
      $('.m-subnav-current').empty().append('<b> - ' + active + '</b>');
    }
  }

  $(window).resize(function () {
    return setWaypoint();
  });
});

$(window).on('load', function () {
  return setWaypoint();
});

function toggleDockSubnav() {
  if (!subnavIsDockable) return;

  if (typeof subnavWaypoint == 'undefined') setWaypoint();
  if (typeof subnavWaypoint == 'undefined') return;

  var st = $(window).scrollTop(),
      wp = subnavWaypoint;

  if ($eyebrow.data('is-visible') || window.innerWidth <= _headerNav.navBreakpoint - 1) {
    wp = subnavWaypoint - $header.outerHeight();
  } else if ($header.getTranslateY()) {
    wp = subnavWaypoint - $header.outerHeight() - $header.getTranslateY();
  }

  if (st > wp) {
    $subnav.removeClass('is-static').addClass('is-fixed');
  } else {
    $subnav.removeClass('is-fixed').addClass('is-static');
  }
}

function addSubnavWrapper() {
  if (!subnavIsDockable) return;
  var $wrap = $('.m-subnav-wrapper');
  if ($wrap.length) return;
  $wrap = $('<div class="m-subnav-wrapper" />').height($subnav.outerHeight());
  $subnav.wrap($wrap);
}

function setWaypoint() {
  var $wrap = $('.m-subnav-wrapper');
  if ($wrap.length && subnavIsDockable) subnavWaypoint = $wrap.offset().top;
}

$.fn.extend({
  getTranslateY: function getTranslateY() {
    if (!$(this).length || $(this).css('transform') == 'none') return 0;
    return parseFloat($(this).css('transform').split(',')[5].replace(')', ''));
  }
});

exports.toggleDockSubnav = toggleDockSubnav;

},{"../header-nav/header-nav":28}]},{},[1]);
